export default "/images/GLB-ACT_Compliant_Logo.png";